/**
 * APIs 配置
 *
 * name   调用方法名
 * url    请求路径
 * method 请求方式
 */
const API_CONFIG = {
  getUserInfo: {
    name: 'getUserInfo',
    url: '/user_info',
    baseUrl: '/api/v2',
    method: 'get',
  },
  getComposedInitSession: {
    name: 'getComposedInitSession',
    baseUrl: '/api/v2',
    url: '/composed_init_session',
    method: 'get',
  },
  getFirstInitSession: {
    name: 'getFirstInitSession',
    baseUrl: '/api/v2',
    url: '/init_session_v1',
    method: 'get',
  },
  getInitSession: {
    name: 'getInitSession',
    baseUrl: '/api/v2',
    url: '/init_session',
    method: 'get',
  },
  // 废弃 after v1.1.1 admin版本
  getHotQuestion: {
    name: 'getHotQuestion',
    url: '/hot_question',
    method: 'get',
  },
  getHotQuestionAnswer: {
    name: 'getHotQuestionAnswer',
    url: '/hot_question_answer',
    method: 'get',
  },
  // 废弃 after v1.1.1 admin版本
  getShortcut: {
    name: 'getShortcut',
    url: '/shortcut',
    method: 'get',
  },
  getShortcutAnswer: {
    name: 'getShortcutAnswer',
    url: '/shortcut_answer',
    method: 'get',
  },
  getArticleByNumber: {
    name: 'getArticleByNumber',
    url: '/get_article_by_number',
    method: 'post',
  },
  isOrderReturn: {
    name: 'isOrderReturn',
    url: '/is_order_return',
    method: 'post',
  },
  postMessage: {
    name: 'postMessage',
    baseUrl: '/api/v2',
    url: '/message',
    method: 'post',
  },
  updateNoLoginMessage: {
    name: 'updateNoLoginMessage',
    baseUrl: '/api/v2',
    url: '/update_nologin_message',
    method: 'post',
  },
  postFeedback: {
    name: 'postFeedback',
    baseUrl: '/api/v2',
    url: '/dialogue_feedback',
    method: 'post',
  },
  getOrderList: {
    name: 'getOrderList',
    url: '/order_list',
    baseUrl: '/api/v2',
    method: 'get',
  },
  getSearchOrderList: {
    name: 'getSearchOrderList',
    url: '/order_search',
    method: 'get',
  },
  postShopeePayActivated: {
    name: 'postShopeePayActivated',
    url: '/is_shopeepay_activated',
    method: 'post',
  },
  postHeartbeat: {
    name: 'postHeartbeat',
    url: '/heartbeat',
    baseUrl: '/api/v2',
    method: 'post',
  },
  getReturnList: {
    name: 'getReturnList',
    url: '/return_list',
    baseUrl: '/api/v2',
    method: 'get',
  },
  postNegativeOptions: {
    name: 'postNegativeOptions',
    baseUrl: '/api/v2',
    url: '/submit_option',
    method: 'post',
  },
  reportLog: {
    name: 'reportLog',
    url: '/report_log',
    method: 'post',
  },
  transactionsLoadMore: {
    name: 'transactionsLoadMore',
    url: '/transactions_load_more',
    method: 'get',
  },
  suggestion: {
    name: 'suggestion',
    baseUrl: '/api/v2',
    url: '/suggestion',
    method: 'post',
  },
  getArticle: {
    name: 'getArticle',
    url: '/article',
    baseUrl: '/api/v2',
    method: 'get',
  },
  getChatHistory: {
    name: 'getChatHistory',
    url: '/user_message_history',
    baseUrl: '/api/v2',
    method: 'get',
  },
  getArticleContent: {
    name: 'getArticleContent',
    baseUrl: '/api/v2',
    url: '/article',
    method: 'get',
  },
  uploadMessage: {
    name: 'uploadMessage',
    url: '/upload_message',
    baseUrl: '/api/v2',
    method: 'post',
  },
  getNextHeadIntent: {
    name: 'getNextHeadIntent',
    url: '/next_head_intent',
    method: 'post',
  },
  popHeadIntent: {
    name: 'popHeadIntent',
    baseUrl: '/api/v2',
    url: '/pop_head_intent',
    method: 'post',
  },
  refreshHeadIntent: {
    name: 'refreshHeadIntent',
    url: 'refresh_head_intent',
    method: 'post',
  },
  getCategoryIntentList: {
    name: 'getCategoryIntentList',
    baseUrl: '/api/v2',
    url: '/get_category_intent_list',
    method: 'get',
  },
  getIntentSolution: {
    name: 'getIntentSolution',
    baseUrl: '/api/v2',
    url: '/solution',
    method: 'get',
  },
  postEndSession: {
    name: 'postEndSession',
    baseUrl: '/api/v2',
    url: '/end_session',
    method: 'post',
  },
  getSupportCaseCount: {
    name: 'getSupportCaseCount',
    url: '/case/get_counts',
    baseUrl: '/api/v2',
    method: 'get',
  },
  getUserEvents: {
    name: 'getUserEvents',
    baseUrl: '/chat/v1',
    url: '/get_user_events',
    method: 'post',
  },
  reportUserEvents: {
    name: 'reportUserEvents',
    baseUrl: '/chat/v1',
    url: '/report_user_event',
    method: 'post',
  },
  getWebformSubmission: {
    name: 'getWebformSubmission',
    baseUrl: '/chat/v1',
    url: '/query_webform_submission',
    method: 'get',
  },
  getStaticResources: {
    name: 'getStaticResources',
    url: '/avatars',
    baseUrl: '/api/v2',
    method: 'get',
  },
  refreshIntents: {
    name: 'refreshIntents',
    url: '/refresh_intents',
    baseUrl: '/api/v2',
    method: 'get',
  },
  getBankStaticResource: {
    name: 'getBankStaticResource',
    baseUrl: '/chat/v1',
    url: '/avatars',
    method: 'get',
  },
  cancelQueuingNotice: {
    name: 'cancelQueuingNotice',
    baseUrl: '/chat/v2',
    url: '/session/ack_queuing_notice',
    method: 'put',
  },
  getUserSwitch: {
    name: 'getUserSwitch',
    url: 'user_switch',
    baseUrl: '/api/v2',
    method: 'get',
  },
  getFoodBuyerOrderList: {
    name: 'getFoodBuyerOrderList',
    url: 'query_order_list',
    baseUrl: '/api/v2',
    method: 'post',
  },
  queryOrderList: {
    name: 'queryOrderList',
    url: '/query_order',
    baseUrl: '/api/v2',
    method: 'get',
  },
  getLiveAgentConnectionInfo: {
    name: 'getLiveAgentConnectionInfo',
    url: '/live_agent_connection/info',
    baseUrl: '/api/v2',
    method: 'get',
    timeout: 2000,
  },
  getExperiment: {
    name: 'getExperiment',
    url: '/experiment/all',
    baseUrl: '/api/v2',
    method: 'get',
  },
  submitProbingForm: {
    name: 'submitProbingForm',
    url: '/live_agent_connection/probing_form',
    baseUrl: '/api/v2',
    method: 'post',
  },
  joinedQueue: {
    name: 'joinedQueue',
    url: '/live_agent_connection/joined_queue',
    baseUrl: '/api/v2',
    method: 'post',
  },
  liveAgentGetVariable: {
    name: 'liveAgentGetVariable',
    url: '/live_agent_connection/get_variable',
    baseUrl: '/api/v2',
    method: 'get',
  },
  liveAgentUpdateVariable: {
    name: 'liveAgentUpdateVariable',
    url: '/live_agent_connection/update_variable',
    baseUrl: '/api/v2',
    method: 'post',
  },
  virtualCallStatusCheck: {
    name: 'virtualCallStatusCheck',
    url: '/live_agent_connection/status_check',
    baseUrl: '/api/v2',
    method: 'get',
  },
  getLandingPagePredict: {
    name: 'getLandingPagePredict',
    url: 'landing_page_predict',
    baseUrl: '/api/v2',
    method: 'get',
  },
  reportTransferType: {
    name: 'reportTransferType',
    url: '/live_agent_connection/report_session_transfer',
    baseUrl: '/api/v2',
    method: 'post',
  },
  queryQueueAvailability: {
    name: 'queryQueueAvailability',
    url: '/live_agent_connection/query_queue_availability',
    baseUrl: '/api/v2',
    method: 'get',
  },
  queryUserCaseList: {
    name: 'queryUserCaseList',
    url: '/live_agent_connection/get_user_case_list',
    baseUrl: '/api/v2',
    method: 'get',
  },
  postExpediteDelivery: {
    name: 'postExpediteDelivery',
    url: 'tf_api_proxy',
    baseUrl: '/api/v2',
    method: 'post',
  },
  getDeliveryInstructions: {
    name: 'getDeliveryInstructions',
    url: 'tf_api_proxy',
    baseUrl: '/api/v2',
    method: 'post',
  },
  updateDeliveryInstructions: {
    name: 'updateDeliveryInstructions',
    url: 'tf_api_proxy',
    baseUrl: '/api/v2',
    method: 'post',
  },
  getChatbotFeedbackKeys: {
    name: 'getChatbotFeedbackKeys',
    url: '/get_csat_reasons',
    baseUrl: '/api/v2',
    method: 'get',
  },
  submitChatbotFeedback: {
    name: 'submitChatbotFeedback',
    url: '/submit_csat',
    baseUrl: '/api/v2',
    method: 'post',
  },
  submitWebform: {
    name: 'submitWebform',
    url: 'query_order_list',
    baseUrl: '/api/v2',
    method: 'post',
  },
  isMultipleWebform: {
    name: 'isMultipleWebform',
    url: 'query_order_list',
    baseUrl: '/api/v2',
    method: 'post',
  },
  queryUserCaseList: {
    name: 'queryUserCaseList',
    url: '/live_agent_connection/get_user_case_list',
    baseUrl: '/api/v2',
    method: 'get',
  },
  getLiveAgentButtons: {
    name: 'getLiveAgentButtons',
    url: '/live_agent_connection/get_live_agent_buttons',
    baseUrl: '/api/v2',
    method: 'get',
  },
  getPreCheckInbound: {
    name: 'getPreCheckInbound',
    url: '/live_agent_connection/pre_check_inbound',
    baseUrl: '/api/v2',
    method: 'get',
  }
};

export const BOT_MESSAGE_API = {
  getCategoryIntentList: API_CONFIG.getCategoryIntentList,
  getHotQuestionAnswer: API_CONFIG.getHotQuestionAnswer,
  postMessage: API_CONFIG.postMessage,
  postNegativeOptions: API_CONFIG.postNegativeOptions,
  getShortcutAnswer: API_CONFIG.getShortcutAnswer,
  getIntentSolution: API_CONFIG.getIntentSolution,
  postFeedback: API_CONFIG.postFeedback,
  getArticle: API_CONFIG.getArticle,
  refreshIntents: API_CONFIG.refreshIntents,
};

// 与chatbot有interaction的接口，考虑可扩展性
export const BOT_INTERACTION_API = {
  getCategoryIntentList: API_CONFIG.getCategoryIntentList,
  getHotQuestionAnswer: API_CONFIG.getHotQuestionAnswer,
  postMessage: API_CONFIG.postMessage,
  getShortcutAnswer: API_CONFIG.getShortcutAnswer,
  getIntentSolution: API_CONFIG.getIntentSolution,
  getArticle: API_CONFIG.getArticle,
};

// 与chatbot有interaction的接口，决定是否弹出CSAT
export const CSAT_BOT_INTERACTION_API = {
  getHotQuestionAnswer: API_CONFIG.getHotQuestionAnswer,
  postMessage: API_CONFIG.postMessage,
  getShortcutAnswer: API_CONFIG.getShortcutAnswer,
  getIntentSolution: API_CONFIG.getIntentSolution,
};

export const LIVE_AGENT_CONTROL_API = {
  getCategoryIntentList: API_CONFIG.getCategoryIntentList,
  getHotQuestionAnswer: API_CONFIG.getHotQuestionAnswer,
  postMessage: API_CONFIG.postMessage,
  getShortcutAnswer: API_CONFIG.getShortcutAnswer,
  getIntentSolution: API_CONFIG.getIntentSolution,
  getArticle: API_CONFIG.getArticle,
};

// 除 init session 外会返回 replies 的接口
export const REPLIES_APIS = [
  'getCategoryIntentList',
  'postMessage',
  'getIntentSolution',
  'postFeedback',
  'postNegativeOptions',
];

// 只控制了由 FE 主动触发的接口，其他的皆由 BE 直接或间接触发不需要控制
export const ONLY_TRIGGER_WHEN_HAS_CHATBOT_APIS = [API_CONFIG.joinedQueue, API_CONFIG.getExperiment];

export default API_CONFIG;
